import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-textcounter', 'remaining', 'tähemärki');
Labels.set('ui-textcounter', 'invalid', 'Kasuta kuni %d tähemärki.');
